import {
  Typography,
  Avatar,
  Button,
  Input,
  Tabs,
  TabsHeader,
  Tab,
  IconButton,
} from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { Link, useLocation } from "react-router-dom";
import Pagination from "../../components/Pagination";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ArrowUpTrayIcon, CheckBadgeIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDownIcon, EllipsisVerticalIcon, HomeIcon, MagnifyingGlassIcon, PencilSquareIcon, PlusCircleIcon, TrashIcon, XCircleIcon, EyeIcon, ArrowDownTrayIcon } from "@heroicons/react/24/solid";
import { StarIcon as StarSolidIcon } from "@heroicons/react/24/solid";
import { PlusIcon, StarIcon as StarOutlineIcon } from "@heroicons/react/24/outline";

import { bulkActionUpdate, deleteProduct, fatchProduct, setSelectedProduct, acceptProduct, fetchMainCategories, fetchCategories, fetchSubCategories, downloadProductCSVFormat, resetStatus } from "@/store/slices/productSlice";
import Select from 'react-select';
import { Popover } from 'react-tiny-popover';
import ShowLoader from "@/components/Loader";
import Toaster from "../../components/Toaster";
import useHasPermission from "../../components/useHasPermission";
import ProductAvailableVendor from "./available-vendor";
import ScrollToTop from "@/components/ScrollToTop";
import RFQCreate from "../../pages/rfqs/rfq-modals/create-normal-rfq-modal";
import ProductVariantSelector from "./product-varients";
import { fetchCartItem } from "@/store/slices/rfqSlice";
import UploadProductsModal from "./upload-products-modal";
import { handleDownloadURL } from "@/components/DownloadFile";
import { getCurrencies } from "@/store/slices/currencySlice";


const action_options2 = [
  {
    label: 'Approve',
    value: 'approved'
  },
  {
    label: 'Delete',
    value: 'deleted'
  },
];


export function Product() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const { t } = useTranslation('product');
  const { t: ct } = useTranslation('common');

  const [productId, setProductId] = useState(null);
  const [search, setSearch] = useState('');
  const [mainCategoryFilter, setMainCategoryFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [subCategoryFilter, setSubCategoryFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [checkedItems, setCheckedItems] = useState([]);
  const [checkedAction, setCheckedAction] = useState('');
  const [isCheckedItemPopoverOpen, setIsCheckedItemPopoverOpen] = useState(false);
  const hasAddPermission = useHasPermission(`product.add`);
  const hasViewPermission = useHasPermission(`product.view`);
  const hasUpdatePermission = useHasPermission(`product.update`);
  const hasDeletePermission = useHasPermission(`product.delete`);
  const hasProductPurchasePriceViewPermission = useHasPermission(`product-purchase-price.view`);
  const hasProductSalePriceViewPermission = useHasPermission(`product-sale-price.view`);
  const [openAvailableVendor, setOpenAvailableVendor] = useState(false);
  const [isCreateRFQModalOpen, setIsCreateRFQModalOpen] = useState(false);
  const [isUploadProduct, setIsUploadProduct] = useState(false);
  const [currencyFilter, setCurrencyFilter] = useState('');
  

  // const [actionOptions1, setActionOptions1] = useState([
  //   {
  //     label: 'Active',
  //     value: 'active'
  //   },
  //   {
  //     label: 'Inactive',
  //     value: 'inactive'
  //   },
  //   {
  //     label: 'Delete',
  //     value: 'deleted'
  //   }]
  // );
  const [actionOptions1, setActionOptions1] = useState([
    {
      label: t('active'),
      value: 'active'
    },
    {
      label: t('inactive'),
      value: 'inactive'
    },
    {
      label: t('delete'),
      value: 'deleted'
    }]
  );

  const user = useSelector((state) => state.user.user);

  const [activeTab, setActiveTab] = useState("all");
  const [isPopoverOpen, setIsPopoverOpen] = useState([]);
  const openActionPopover = (id) => {
    setIsPopoverOpen((prev) => {
      if (prev.includes(id)) {
        return [];
      } else {
        return [id];
      }
    });
  };

  useEffect(() => {
    dispatch(fatchProduct({ activetab: activeTab, page: currentPage, perPage: itemsPerPage, search: search, maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter, currencyCode: currencyFilter }));
    dispatch(fetchMainCategories());
    dispatch(fetchCategories(mainCategoryFilter));
    dispatch(fetchSubCategories(categoryFilter));
  }, [dispatch, currentPage, activeTab, itemsPerPage]);

  useEffect(() => {
    dispatch(fatchProduct({ activetab: activeTab, page: 1, perPage: itemsPerPage, search: search, maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter, currencyCode: currencyFilter }));
    dispatch(fetchMainCategories());
    dispatch(fetchCategories(mainCategoryFilter));
    dispatch(fetchSubCategories(categoryFilter));
  }, [mainCategoryFilter, categoryFilter, subCategoryFilter, currencyFilter]);

  const { list_products, loading, list_loading } = useSelector((state) => state.product);
  const { main_categories, categories, sub_categories } = useSelector((state) => state.product);
  const { cart_item_loading } = useSelector((state) => state.rfq);
  const handelSearch = (event) => {
    const value = event.target.value;

    if (event.key === "Enter" && value) {
      dispatch(fatchProduct({ activetab: activeTab, page: 1, perPage: itemsPerPage, search: value, maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter }));
    } else if (event.key === "Backspace" && value.length === 0) {
      dispatch(fatchProduct({ activetab: activeTab, page: 1, perPage: itemsPerPage, search: '', maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter }));
    }
  }

  const handleSearchClick = () => {
    dispatch(fatchProduct({ activetab: activeTab, page: 1, perPage: itemsPerPage, search: search, maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter }));
  }

  const handelRemoveSearch = () => {
    setSearch('');
    dispatch(fatchProduct({ activetab: activeTab, page: 1, perPage: itemsPerPage, search: '', maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter }));
  }

  const handelEdit = (id, mode = "edit") => {
    if (id) {
      const product = list_products?.products?.find((row) => String(row.id) === String(id));
      dispatch(setSelectedProduct(product));
      navigate(`/dashboard/products/${mode}/${id}`);
      setIsPopoverOpen([]);
    }
  }

  const handelCheckedItems = (action) => {
    setCheckedAction(action);
    setIsCheckedItemPopoverOpen(false);
    if (checkedItems.length) {
      if (action === 'Create RFQ') {
        dispatch(fetchCartItem(checkedItems)).unwrap().then((res) => {
          if (res?.status) {
            setIsCreateRFQModalOpen(true);
          } else {
            Toaster.error(res?.message || 'Please select only products that are currently active.');
          }
        });
      } else {
        Swal.fire({
          title: ct("areYouSure"),
          text: t('performActionConfirmation'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: ct("yes")
        }).then((result) => {
          if (result.isConfirmed) {
            let payload = { status: action, ids: checkedItems };
            if (action === 'approved') {
              payload = { is_approved: 'yes', ids: checkedItems };
            }
            dispatch(bulkActionUpdate(payload)).unwrap().then((res) => {
              Toaster.success(res?.message || t('productUpdatedSuccess'));
              setCheckedItems([]);
              setCheckedAction('');
              dispatch(fatchProduct({ activetab: activeTab, page: currentPage, perPage: itemsPerPage, search: search, maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter, currencyCode: currencyFilter }));
            }).catch((error) => {
              Toaster.error(t('actionFailedError'));
            });
          }
        });
      }
    } else {
      Toaster.error(t('selectItemError'));
    }
  }

  const handleSingleCheck = (value) => {
    if (checkedItems.includes(value)) {
      setCheckedItems(checkedItems.filter((v) => v !== value));
    } else {
      setCheckedItems([...checkedItems, value]);
    }
  };

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      const ids = list_products?.products?.map((row) => row.id) || [];
      setCheckedItems(ids);
    } else {
      setCheckedItems([]);
    }
  };

  const isAllChecked =
    list_products?.products?.length > 0 &&
    checkedItems.length === list_products.products.length;

  const delete_row = (id) => {
    Swal.fire({
      title: ct("areYouSure"),
      text: ct("cannotUndo"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: ct("yesDeleteIt")
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteProduct(id)).unwrap().then(() => {
          Toaster.success(t("productDeletedSuccess"));
          dispatch(fatchProduct({ activetab: activeTab, page: currentPage, perPage: itemsPerPage, search: search, maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter, currencyCode: currencyFilter }));
        }).catch((error) => {
          console.error("Delete failed:", error);
          Toaster.error(t("deleteFailedError"));
        });
      }
      setIsPopoverOpen([]);
    });
  }

  const acceptRejectProduct = async (id, key, value) => {
    let msg = "";
    if (key === "is_approved") {
      msg = value === "yes" ? "approve" : "reject";
    } else if (key === "is_featured") {
      msg = value === "yes" ? "featured" : "unfeatured";
    } else {
      msg = (key === "status" && value === 'active') ? "activate" : "inactivate";
    }
    let actionVerbs = ["approve", "reject"];
    let text;
    if (actionVerbs.includes(msg.toLowerCase())) {
      text = `Do you want to ${msg} this product?`;
    } else {
      text = `Do you want to make this product ${msg}?`;
    }
    Swal.fire({
      title: ct("areYouSure"),
      text: `${text}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: ct("yes")
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(acceptProduct({ id, key, value })).unwrap().then((res) => {
          const pastTenseMap = {
            'active': 'activated',
            'inactive': 'inactivated',
            'approved': 'approved',
            'rejected': 'rejected',
          };
          const pastTenseMsg = pastTenseMap[res.status] ?? res.status + "ed";
          Toaster.success(t('productStatusSuccess', { status: pastTenseMsg }));
          dispatch(fatchProduct({ activetab: activeTab, page: currentPage, perPage: itemsPerPage, search: search, maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter, currencyCode: currencyFilter }));
        }).catch((error) => {
          console.error("Changes failed:", error);
          Toaster.error(t('actionFailedError'));
        });
        setIsPopoverOpen([]);
      }
    });
  };

  const popoverRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(e) {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setIsPopoverOpen([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handelOpen = (isOpen, product_id) => {
    if (isOpen) {
      setProductId(product_id);
    } else {
      setProductId(null);
      dispatch(fatchProduct({ activetab: activeTab, page: currentPage, perPage: itemsPerPage, search: search, maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter, currencyCode: currencyFilter }));
    }
    setOpenAvailableVendor(isOpen);
  }

  const tabs = [
    {
      key: "all",
      label: t('allProductsTab'),
      count: list_products?.total_all_product || 0,
    },
    {
      key: "approval_request",
      label: t('approvalsTab'),
      count: list_products?.total_draft_product || 0,
    },
  ];

  const [selectedVariants, setSelectedVariants] = useState({});

  const setProductSelectedColorSize = (product_id, type, variant_id) => {
    setSelectedVariants((prev) => ({
      ...prev,
      [product_id]: {
        ...prev[product_id],
        [type]: variant_id,
      },
    }));
  };

  const hasRFQCreatePermission = useHasPermission(`rfq.add`);
  const hasRFQUpdatePermission = useHasPermission(`rfq.update`);
  const isSalesAdmin = user.roles == 'Sales Representative';


  useEffect(() => {
    setActionOptions1((prev) => {
      // 1. Remove existing "Create RFQ" / "Add RFQ Item"
      let updated = prev.filter(
        (option) =>
          option.value !== "Create RFQ"
      );

      // 2. Add based on condition
      if (hasRFQCreatePermission && !isSalesAdmin && state === null) {
        updated.push({
          label: t('createRfqButton'),
          value: "Create RFQ",
        });
      }
      else if (hasRFQUpdatePermission && state?.rfq_id) {
        updated.push({
          label: t('addRfqItemButton'),
          value: "Create RFQ",
        });
      }

      return updated;
    });
  }, [
    hasRFQCreatePermission,
    hasRFQUpdatePermission,
    isSalesAdmin,
    state,
    user
  ]);

  const columns = [
    t('productNameHeader'),
    ct('status'),
    t('subCategoryHeader'),
    t('installationHeader'),
    ...(hasProductPurchasePriceViewPermission ? [t('purchasePriceHeader')] : []),
    ...(hasProductSalePriceViewPermission ? [t('salePriceHeader')] : []),
    t('vendorHeader'),
    ""
  ];

  const downloadCSVFormat = async () => {
      try {
        const result = await dispatch(downloadProductCSVFormat()).unwrap();
          if (result?.status) {
              handleDownloadURL({ fileUrl: result?.data?.csv_url });
            Toaster.success(`Product CSV format downloaded successfully.`);
              dispatch(resetStatus());
          } else {
              Toaster.error(result.message || "Something went wrong!");
              dispatch(resetStatus());
          }
      } catch (err) {
          Toaster.error(err?.message || "Failed to download.");
          dispatch(resetStatus());
      }
  }
  const currencyCode = localStorage.getItem("currency_code");

  const { currencies } = useSelector((state) => state.currentCurrency);
 

  useEffect(() =>{
    dispatch(getCurrencies());
  },[]);

  const currencyOptions =
    currencies?.map((currency) => ({
        value: currency.id,
        label: `${currency.currency_code} - ${currency.country_name}`,
    })) || [];

  return (
    <div className="mt-5 mb-8 flex flex-col gap-8">
      {(loading || cart_item_loading) && <ShowLoader />}
      <ScrollToTop />
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0 px-4 md:px-6">
        <div className="w-full md:flex-1">
          <Typography variant="h5" color="blue-gray">
            {t('productListTitle')}
          </Typography>
        </div>
        <div className="w-full md:flex-1 flex justify-center">
          <div className="w-full max-w-md relative">
            <Input className={search ? 'pr-10' : ''} label={t('searchProductPlaceholder')} icon={!search ? <MagnifyingGlassIcon className="h-5 w-5" /> : ''} value={search} onChange={(e) => setSearch(e.target.value)} onKeyUp={handelSearch} />
            {search && (
              <IconButton variant="text" size="sm" className="!absolute right-1 top-1" onClick={handelRemoveSearch}>
                <XCircleIcon className="h-5 w-5 text-red-500" />
              </IconButton>
            )}
          </div>
          {search && (<Button variant="outlined" className="flex items-center border-gray-300 capitalize font-bold bg-black text-white mx-2" //NOSONAR
            onClick={handleSearchClick}
          ><MagnifyingGlassIcon className="w-4 h-4 mr-1" /> {ct('search')}</Button>)}
        </div>
        {hasAddPermission && <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 px-4 md:px-6">
          {/* <Link to="#">
            <Button variant="outlined" className="flex items-center gap-2 border-gray-300 capitalize font-bold bg-black text-white"><ArrowUpTrayIcon className="w-4 h-4" />  Bulk Upload </Button>
          </Link> */}
          <Link to="/dashboard/products/add">
            <Button variant="outlined" className="flex items-center gap-2 border-gray-300 capitalize font-bold bg-black text-white"><PlusCircleIcon className="w-4 h-4" />    {t('addProductButton')} </Button>
          </Link>
          <Button
            variant="outlined"
            className="flex items-center gap-2 border-gray-300 capitalize"
            onClick={() => downloadCSVFormat()}
          >
            <ArrowDownTrayIcon className="h-4 w-4" />
            {ct('download')}
          </Button>
          <Button
              variant="outlined"
            className="flex items-center gap-2 border-gray-300 capitalize"
            onClick={()=>setIsUploadProduct(true)}
          >
            <ArrowUpTrayIcon className="h-4 w-4" />
            {t('bulkUploadButton')}
          </Button>
        </div>}
      </div>
      {/* <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0 px-4 md:px-6">
        <div className="w-96">
          <Tabs value="app">
            <TabsHeader>
              <Tab value="app" color="black" onClick={() => setActiveTab('all')}>
                All Products {activeTab !== 'all' ? '(' + list_products?.total_all_product + ')' : ''}
              </Tab>
              <Tab value="settings" onClick={() => setActiveTab('approval_request')}>
                Products for Approvals {activeTab !== 'approval_request' ? '(' + list_products?.total_draft_product + ')' : ''}
              </Tab>
            </TabsHeader>
          </Tabs>
        </div>
      </div> */}
      {!user.roles.includes('Vendor') && <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0 px-4 md:px-6">
        <div className="w-full md:w-auto relative">
          <div className="flex bg-gray-100 rounded-2xl p-1 shadow-sm relative">
            {tabs.map((tab, index) => {
              const isActive = activeTab === tab.key;
              return (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`relative min-w-[180px] text-sm font-semibold px-6 py-2 rounded-2xl transition-colors duration-300 z-10
                  ${isActive ? "text-white" : "text-gray-700 hover:text-black"}`}
                >
                  {tab.label}{" "}
                  {activeTab !== tab.key && (
                    <span className="text-gray-700 text-xs ml-1">({tab.count})</span>
                  )}

                  {/* Active Background */}
                  {isActive && (
                    <span className="absolute inset-0 bg-black rounded-2xl z-[-1] transition-all duration-300"></span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </div>}
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-2 px-4 md:px-6">
        <div className="w-full md:flex-1">
          <Typography variant="h6" color="blue-gray" className="whitespace-nowrap">
            {ct('items')} ({list_products?.pagination?.total || 0})
          </Typography>
        </div>
        <div className="flex items-center gap-1">
           <Select
            placeholder={t("selectCountryPlaceholder")}
            options={currencyOptions}
            onChange={(currency) => {
                if (currency?.value) {
                setCurrencyFilter(currency?.value);
              } else {
                setCurrencyFilter('');
              }
            }}
            isClearable
            />
          <Select
            placeholder={t('selectCategoryPlaceholder')}
            onChange={(cat) => {
              if (cat?.value) {
                setMainCategoryFilter(cat?.value);
              } else {
                setMainCategoryFilter('');
              }
            }}
            options={main_categories}
            isClearable
          />
         
          <Select
            placeholder={t('selectSubCategory1Placeholder')}
            onChange={(cat) => {
              if (cat?.value) {
                setCategoryFilter(cat?.value);
              } else {
                setCategoryFilter('');
              }
            }}
            options={categories}
            isClearable
          />
          <Select
            className="placeholder-nowrap"
            placeholder={t('selectSubCategory2Placeholder')}
            onChange={(cat) => {
              if (cat?.value) {
                setSubCategoryFilter(cat?.value);
              } else {
                setSubCategoryFilter('');
              }
            }}
            options={sub_categories}
            isClearable
          />
          <Popover
            isOpen={isCheckedItemPopoverOpen}
            positions={["bottom"]}
            padding={4}
            onClickOutside={() => setIsCheckedItemPopoverOpen(false)}
            content={
              <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                {activeTab === 'all' && actionOptions1?.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => {
                      handelCheckedItems(option.value);
                    }}
                    className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize"
                  >
                    {option.label}
                  </button>
                ))}
                {activeTab === 'approval_request' && action_options2?.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => {
                      handelCheckedItems(option.value);
                    }}
                    className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize"
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            }
          >
            <Button
              onClick={() => setIsCheckedItemPopoverOpen(!isCheckedItemPopoverOpen)}
              variant="outlined"
              className="flex items-center gap-2 border-gray-300 capitalize font-bold bg-black text-white whitespace-nowrap"
            >
              {t('selectedItemsButton')} <ChevronDownIcon className="h-4 w-4" />
            </Button>
          </Popover>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[800px] table-auto text-left">
          <thead>
            <tr>
              <th
                className="border-b border-blue-gray-50 py-3 px-5 text-left"
              >
              <div className="flex items-center gap-4">
                <input
                  type="checkbox"
                  className="w-4 h-4 accent-green cursor-pointer"
                  onChange={(e) => handleCheckAll(e)}
                  checked={isAllChecked}
                />
                <Typography className="text-[12px] font-bold text-black-gray"
                  variant="small"
                >{t('addItemInstruction')}</Typography>
                <Typography
                  variant="small"
                  className="text-[11px] font-bold text-black-gray hover:underline hover:text-blue-600 cursor-pointer"
                  onClick={() => navigate('/dashboard/products/add')}
                >
                  {t('addItemLink')}
                </Typography>
              </div>
              </th>
              {columns.map((el, col) => (
                <th
                  key={col}
                  className="border-b border-blue-gray-50 py-3 px-5 text-left"
                >
                  <Typography
                    variant="small"
                    className="text-[11px] font-bold text-black-gray"
                  >
                    {el}
                  </Typography>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {list_loading ? <tr><td colSpan={8} className="text-center"> <div role="status">
              <svg aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
              </svg>
            </div></td></tr> : ''}

            {list_products?.products?.length > 0 ? list_products?.products.map(
              ({ id, main_image, name, sku_number, product_varients = [], varients = [], colors = [], sub_category_name, installation_charges = [], available_vendors = [], is_approved, _status, status, is_featured }, key) => {
                const className = `py-3 px-5 ${key === list_products?.products.length - 1
                  ? ""
                  : "border-b border-blue-gray-50"
                  }`;
                const selectedColorId = selectedVariants[id]?.color_id;
                const selectedSizeId = selectedVariants[id]?.size_id;

                const selectedVariant = varients?.find(
                  v =>
                    v.attribute_value_color_id === selectedColorId &&
                    v.attribute_value_size_id === selectedSizeId
                );

                let image =
                    colors
                        ?.find((color) => (color.color_attribute_id === selectedColorId && color.size_attribute_id === selectedSizeId)) 
                        ?.image || null;

                const installationCharge = installation_charges?.find(
                  (charge) => charge.currency?.currency_code === currencyCode
                );

                return (
                  <tr key={id}>
                    <td className={className}>
                      <div className="flex items-center gap-6">
                        <input type="checkbox"
                          className="w-4 h-4 accent-green cursor-pointer"
                          onChange={() => handleSingleCheck(id)}
                          checked={checkedItems.includes(id)}
                        />
                        <div className="h-[36px] w-[60px]"><Avatar src={image ?? main_image ?? '/img/photo-gallery.png'} alt={name} size="sm" variant="rounded" className="h-[100%] w-[100%] fit-contain"/></div>
                        <div>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-semibold break-all w-[120px] max-w-[120px]"
                          >
                            {sku_number}
                          </Typography>

                        </div>
                        {product_varients && <div className="flex flex-col min-w-0 w-full">
                          <ProductVariantSelector
                            variants={product_varients}
                            onColorChange={(color_id) => setProductSelectedColorSize(id, 'color_id', color_id)}
                            onSizeChange={(size_id) => setProductSelectedColorSize(id, 'size_id', size_id)}
                          />
                        </div>}

                        {/* {product_varients && <div className="flex flex-col min-w-0 w-full">
                          <ProductVariantSelector
                            variants={product_varients.map((variant) => ({
                              ...variant,
                              sizes: variant.sizes?.filter((s) => {
                                const sizeLabel = (s.size || '').trim().toLowerCase();
                                const sizeCode = (s.size_code || '').trim().toUpperCase();
                                return (
                                  sizeLabel !== 'free size' &&
                                  sizeLabel !== 'not applicable' &&
                                  sizeCode !== 'FS' &&
                                  sizeCode !== 'N/A'
                                );
                              }) ?? [],
                            }))}
                            onColorChange={(color_id) => setProductSelectedColorSize(id, 'color_id', color_id)}
                            onSizeChange={(size_id) => setProductSelectedColorSize(id, 'size_id', size_id)}
                          />
                        </div>} */}
                      </div>
                    </td>
                    <td className={className}>
                      <Typography className="text-xs font-normal text-blue-gray-500">
                        {name}
                      </Typography>
                    </td>
                   <td className={className}>
                      <div className="flex flex-col gap-1">
                        <span
                          className={`inline-flex items-center justify-center rounded-xl px-2 py-1 text-xs font-medium w-fit inset-ring inset-ring-green-600/20
                              ${status === 'active'
                              ? 'bg-green-50 text-green-700'
                              : status === 'draft'
                                ? 'bg-amber-100 text-red-600'
                                : 'bg-red-50 text-red-700'
                            }`}
                        >
                          {_status}
                        </span>
                        {is_featured === 'yes' && (
                          <span className="inline-flex items-center justify-center rounded-xl px-2 py-1 text-xs font-medium w-fit bg-yellow-50 text-yellow-800">
                            {t('featuredLabelProduct')}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className={className}>
                      <Typography className="text-xs font-semibold text-blue-gray-600">
                        {sub_category_name}
                      </Typography>
                    </td>
                    <td className={className}>
                      <Typography className="text-xs font-semibold text-blue-gray-600">
                         {installationCharge?.currency?.currency_code}{" "}
                          {installationCharge?.amount ?? "0.00"}
                      </Typography>
                    </td>
                    {hasProductPurchasePriceViewPermission &&
                      <td className={className}>
                        <Typography className="text-xs font-semibold text-blue-gray-600">
                          {selectedVariant?.currency_code}{" "}
                          {selectedVariant ? `${selectedVariant.base_price ?? '_'}` : "—"}
                        </Typography>
                      </td>
                    }
                    {hasProductSalePriceViewPermission &&
                    <td className={className}>
                      <Typography className="text-xs font-semibold text-blue-gray-600">
                          {selectedVariant?.currency_code}{" "}
                          {selectedVariant ? `${selectedVariant.sale_price ?? '_'}` : "—"}
                      </Typography>
                    </td>
                    }
                    <td className={className}>
                      <Typography className="text-xs font-semibold text-blue-gray-600">
                        {available_vendors.length}
                      </Typography>
                    </td>
                    <td className={className}>
                      <div className="flex items-center space-x-2">
                        <Popover
                          isOpen={isPopoverOpen.includes(id)}
                          positions={['bottom', 'left']}
                          padding={4}
                          content={<div ref={popoverRef} className="bg-white shadow-xl rounded-md w-40 flex flex-col z-50 border border-gray-100 py-1 break-words">
                            {hasViewPermission && <button
                              className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                              onClick={() => handelEdit(id, "view")}
                            >
                              <EyeIcon className="h-4 w-4 text-blue-500" />
                              {ct('view')}
                            </button>}
                            {hasUpdatePermission && <button
                              className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                              onClick={() => handelEdit(id, "edit")}
                            >
                              <PencilSquareIcon className="h-4 w-4 text-blue-500" />
                              {ct('edit')}
                            </button>}
                            {hasDeletePermission && <button
                              className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                              onClick={() => delete_row(id)}
                            >
                              <TrashIcon className="h-4 w-4 text-red-500" />
                              {ct('delete')}
                            </button>}
                            {hasUpdatePermission && <>
                              {is_approved === "no" &&
                                <button
                                  className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                  onClick={() => acceptRejectProduct(id, "is_approved", "yes")}
                                >
                                  <CheckBadgeIcon className="h-4 w-4 text-blue-500" />
                                  {ct('approve')}
                                </button>
                              }
                              {(status === "inactive") && (
                                <button
                                  className="flex items-center gap-2 text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                  onClick={() => acceptRejectProduct(id, "status", "active")}
                                >
                                  <CheckBadgeIcon className="h-4 w-4 text-blue-500 flex-shrink-0" />
                                  <span className="whitespace-nowrap">
                                    {t('activateButton')}
                                  </span>
                                </button>
                              )}
                              {(activeTab === 'all' && status === "draft") && (
                                <button
                                  className="flex items-center gap-2 text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                  onClick={() => acceptRejectProduct(id, "status", "active")}
                                >
                                  <CheckBadgeIcon className="h-4 w-4 text-blue-500 flex-shrink-0" />
                                  <span className="whitespace-nowrap">
                                    {t('activatePublishButton')}
                                  </span>
                                </button>
                              )}
                              {activeTab === 'all' && status === "active" &&
                                <button
                                  className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                  onClick={() => acceptRejectProduct(id, "status", "inactive")}
                                >
                                  <XCircleIcon className="h-4 w-4 text-red-500" />
                                  {t('inactivateButton')}
                                </button>
                              }
                              {activeTab === 'all' && status === "active" && is_featured === "yes" &&
                                <button
                                  className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                  onClick={() => acceptRejectProduct(id, "is_featured", "no")}
                                >
                                  <StarOutlineIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                                  {t('unfeatureButton')}
                                </button>
                              }
                              {status === "active" && is_featured === "no" &&
                                <button
                                  className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                  onClick={() => acceptRejectProduct(id, "is_featured", "yes")}
                                >
                                  <StarSolidIcon className="h-4 w-4 text-green-500 cursor-pointer" />
                                  {t('featureButton')}
                                </button>
                              }
                              <button
                                className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                onClick={() => handelOpen(!openAvailableVendor, id)}
                              >
                                <PlusCircleIcon className="h-4 w-4 text-green-500 cursor-pointer" />
                                {t('addVendorButton')}
                              </button>
                            </>}
                          </div>}>
                          <IconButton variant="text" color="blue-gray" onClick={() => openActionPopover(id)}>
                            <EllipsisVerticalIcon className="h-6 w-6" />
                          </IconButton>
                        </Popover>
                      </div>
                    </td>
                  </tr>
                );
              }
            ) : <tr><td colSpan={8} className="text-center py-10 text-blue-gray-500">{ct('noDataFound')}</td></tr>}
          </tbody>
        </table>
      </div>
      {list_products?.pagination && list_products?.pagination.total > 0 && (
        <Pagination currentPage={currentPage} itemsPerPage={itemsPerPage} setCurrentPage={setCurrentPage} setItemsPerPage={setItemsPerPage} totalPages={list_products?.pagination?.last_page} />
      )}
      <ProductAvailableVendor open={openAvailableVendor} handler={handelOpen} productId={productId}></ProductAvailableVendor>
      {isCreateRFQModalOpen && <RFQCreate onClose={() => setIsCreateRFQModalOpen(false)} product_ids={checkedItems} selectedVariants={selectedVariants}></RFQCreate>}

      {isUploadProduct && <UploadProductsModal isOpen={isUploadProduct} onClose={() => {
        setIsUploadProduct(false);
      }} onSubmitted={() => 
          dispatch(fatchProduct({ activetab: activeTab, page: currentPage, perPage: itemsPerPage, search: search, maincategory: mainCategoryFilter, category: categoryFilter, subcategory: subCategoryFilter , currencyCode: currencyFilter}))
      } />}
    </div>
  );
}

export default Product;